import { lazy, type ReactElement } from "react";
import { type RouteProps } from "react-router";
import { TitleRoute } from "../../Common/Routing/TitleRoute";

const Tickets = lazy(() => import("./Tickets"));
const EverydayTickets = lazy(() => import("./EverydayTickets"));
const PromotionalTickets = lazy(() => import("./PromotionalTickets"));
const TemplateIndex = lazy(() => import("./CSS/Template/Templates"));
const TemplateCreate = lazy(() => import("./CSS/Template/TemplateCreate"));
const TemplateModify = lazy(() => import("./CSS/Template/TemplateModify"));
const AdminTemplates = lazy(() => import("./CSS/Template/Admin/AdminTemplates"));
const LayoutIndex = lazy(() => import("./CSS/Layout/Layouts"));
const LayoutCreate = lazy(() => import("./CSS/Layout/LayoutCreate"));
const LayoutModify = lazy(() => import("./CSS/Layout/LayoutModify"));
const AdminLayouts = lazy(() => import("./CSS/Layout/Admin/AdminLayouts"));
const TicketQueue = lazy(() => import("./CSS/Queue/TicketQueue"));
const PrintPreview = lazy(() => import("./CSS/PrintPreview/TicketPrintPreview"));

export default function TicketIndex(): Array<ReactElement<RouteProps>> {
    return [
        <TitleRoute
            title="Shelf Tickets | Shopfront"
            path="/tickets"
            key="tickets"
            element={<Tickets />}
        />,
        <TitleRoute
            title="Everyday Tickets | Shopfront"
            path="/tickets/everyday"
            key="tickets-everyday"
            element={<EverydayTickets />}
        />,
        <TitleRoute
            title="Promotional Tickets | Shopfront"
            path="/tickets/promotion"
            key="tickets-promotions"
            element={<PromotionalTickets />}
        />,
        <TitleRoute
            title="Ticket Templates | Shopfront"
            path="/tickets/css/templates"
            key="ticket-templates"
            element={<TemplateIndex />}
        />,
        <TitleRoute
            title="MDB Templates | Shopfront"
            path="/tickets/css/templates/mdb"
            key="mdb-ticket-templates"
            element={<AdminTemplates />}
        />,
        <TitleRoute
            title="Template New | Shopfront"
            path="/tickets/css/template/new"
            key="ticket-template-new"
            element={<TemplateCreate />}
        />,
        <TitleRoute
            title="Template Modify | Shopfront"
            path="/tickets/css/template/:id"
            key="ticket-template-modify"
            element={<TemplateModify />}
        />,
        <TitleRoute
            title="Layout New | Shopfront"
            path="/tickets/css/layout/new"
            key="ticket-layout-new"
            element={<LayoutCreate />}
        />,
        <TitleRoute
            title="Layout Modify | Shopfront"
            path="/tickets/css/layout/:id"
            key="ticket-layout-modify"
            element={<LayoutModify />}
        />,
        <TitleRoute
            title="Ticket Layouts | Shopfront"
            path="/tickets/css/layouts"
            key="ticket-layouts"
            element={<LayoutIndex />}
        />,
        <TitleRoute
            title="MDB Layouts | Shopfront"
            path="/tickets/css/layouts/mdb"
            key="mbd-ticket-layouts"
            element={<AdminLayouts />}
        />,
        <TitleRoute
            title="Ticket Queue | Shopfront"
            path="/tickets/css/queue"
            key="ticket-queue"
            element={<TicketQueue />}
        />,
        <TitleRoute
            title="Ticket Print | Shopfront"
            path="/tickets/css/print"
            key="ticket-print"
            element={<PrintPreview />}
        />,
    ];
}
